import { Option } from '../../types';

const getTotalAmountOfAppliedOptions = (appliedFacets: { [key: string]: Option[] }, facetName: string) =>
  (appliedFacets[facetName] ? appliedFacets[facetName].length : 0);

export default getTotalAmountOfAppliedOptions;
